import {
  browserFastApiClient,
  requireFastApiAccessToken,
} from "@/core/fastapi";
import {
  clearRagApiRag,
  type ClearRagRequest,
  type ClearRagResponse,
} from "@/generated/fastapi";

export async function clearKnowledge(
  accessToken: string | null | undefined,
  request: ClearRagRequest,
): Promise<ClearRagResponse | null> {
  try {
    const response = await clearRagApiRag({
      client: browserFastApiClient,
      body: request,
      auth: requireFastApiAccessToken(accessToken),
    });

    const clearRagResponse = response.data as ClearRagResponse;

    if (!response || response.data?.status !== "success") {
      console.error("Clear RAG failed response:", clearRagResponse?.message);
      return null;
    }

    return clearRagResponse;
  } catch (error) {
    console.error("Clear RAG error:", error);
    return null;
  }
}
